import { extend } from 'flarum/common/extend';
import Avatar from 'flarum/common/components/Avatar';
/**
 * Modais de formulário longo (less/forum/ModalLayout.less): o CSS distribui
 * os campos em colunas por assunto, mas os itens do core não têm classe que
 * diga qual campo é qual (nome de usuário e e-mail são `.Form-group` iguais).
 * Aqui cada item do ItemList ganha `data-item="<chave>"` na hora de desenhar;
 * nada muda na lógica nem na gravação, e um campo de extensão sem regra só
 * cai na próxima vaga livre da grade.
 */
const MODALS = ['flarum/common/components/EditUserModal'];
function tagItems(children, depth = 0) {
  if (!Array.isArray(children) || depth > 4) return;
  for (const child of children) {
    if (!child || typeof child !== 'object') continue;
    const vnode = child;

    // `toArray()` põe o `itemName` nos itens; só elementos HTML recebem o
    // atributo (num componente ele iria parar nos attrs dele, não no DOM).
    if (typeof vnode.itemName === 'string' && typeof vnode.tag === 'string' && vnode.attrs && typeof vnode.attrs === 'object') {
      vnode.attrs['data-item'] = vnode.itemName;
      continue;
    }
    tagItems(vnode.children, depth + 1);
  }
}

/**
 * Editar usuário só vira modal largo com cinco campos ou mais (o próprio
 * usuário, ou quem só mexe nos grupos, vê três ou quatro). A classe fazia o
 * papel de `.EditUserModal:has(.Form-body > :nth-child(5))`: um `:nth-child`
 * dentro de `:has()` fazia o navegador reavaliar o modal a cada elemento
 * inserido em qualquer lugar da página (os posts carregados na rolagem).
 */
function markLong(element) {
  const body = element?.querySelector('.Form-body');
  element?.classList.toggle('CanelaModal--long', !!body && body.children.length >= 5);
}
export default function installModalLayout() {
  // Módulos carregados sob demanda: estendidos pelo nome.
  for (const module of MODALS) {
    extend(module, 'content', function (vdom) {
      tagItems([vdom]);
    });
  }

  // Quem está sendo editado: avatar, nome e @usuário no topo do modal (a
  // moderação abre o modal de outra pessoa, e o título só dizia "Editar
  // usuário").
  extend('flarum/common/components/EditUserModal', 'content', function (vdom) {
    const user = this.attrs?.user;
    if (!user || !vdom || !Array.isArray(vdom.children)) return;
    vdom.children.unshift(m('div', {
      className: 'CanelaEditUser-identity'
    }, [m(Avatar, {
      user,
      className: 'CanelaEditUser-avatar'
    }), m('div', {
      className: 'CanelaEditUser-names'
    }, [m('span', {
      className: 'CanelaEditUser-name'
    }, user.displayName()), m('span', {
      className: 'CanelaEditUser-username'
    }, `@${user.username()}`)])]));
  });
  extend('flarum/common/components/EditUserModal', 'oncreate', function () {
    markLong(this.element);
  });
  extend('flarum/common/components/EditUserModal', 'onupdate', function () {
    markLong(this.element);
  });
}
flarum.reg.add('ramon-canela', 'forum/shell/modalLayout', installModalLayout);